<script setup>
  import ModalTextInput from '@/components/controls/ModalTextInput.vue';
  import { carrierGroups } from '@/helpers/alertCarriers';

  const name = defineModel('name');
  const phone = defineModel('phone');
  const carrier = defineModel('carrier');
  const maxMessages = defineModel('maxMessages');

  defineProps({
    errors: {
      type: Object,
      default: () => ({})
    },
    valid: {
      type: Object,
      default: () => ({})
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  });

  const emits = defineEmits(['delete']);
</script>

<template>
  <div>
    <div class="jwx-modal__section">
      <div class="jwx-modal__section-body">
      <ModalTextInput
        v-model="name"
        id="device-mobile-name"
        name="device-mobile-name"
        labelText="Name"
        subText="Max 64 characters"
      />
      <div class="jwx-modal__form-control">
        <label for="device-mobile-carrier" class="jwx-modal__control-label jwx-flex">
          Carrier<span class="jwx-modal__control-required" :data-valid="valid.carrier ? 'true' : null">Required</span>
        </label>
        <div class="jwx-modal__input-group" :data-error="errors.carrier ? 'true' : null">
          <div class="jwx-modal__input-wrapper">
            <select
              v-model="carrier"
              id="device-mobile-carrier"
              name="device-mobile-carrier"
              class="jwx-modal__input"
            >
              <option value="" disabled>Select your Carrier...</option>
              <optgroup
                v-for="group in carrierGroups"
                :key="group.country"
                :label="group.country"
              >
                <option
                  v-for="c in group.carriers"
                  :key="c.name + c.template"
                  :value="c.template"
                >{{ c.name }}</option>
              </optgroup>
            </select>
          </div>
        </div>
        <p v-if="errors.carrier" class="jwx-modal__control-error">{{ errors.carrier }}</p>
      </div>
      <ModalTextInput
        v-model="phone"
        id="device-mobile-phone"
        name="device-mobile-phone"
        labelText="Phone Number"
        subText="Enter your local number without country code."
        required
        :errorText="errors.phone"
        :valid="!!valid.phone"
      />
      <ModalTextInput
        v-model="maxMessages"
        id="device-mobile-max-messages"
        name="device-mobile-max-messages"
        labelText="Max Messages"
        subText="Your monthly text alerts will be capped at this amount."
      />
      </div>
    </div>
    <div v-if="canDelete" class="jwx-modal__section jwx-p-jumbo jwx-flex jwx-justify-center">
      <button
        type="button"
        class="jwx-button jwx-button--pill"
        data-type="danger"
        @click.prevent="emits('delete')"
      >
        Delete Device
      </button>
    </div>
  </div>
</template>
